<template>
  <api-table
    defaultSortBy="category.name"
    :tableHeaders="headers"
    :rows-per-page="20"
    :getDataService="productService.getProducts"
    :standardQuery="standardQuery || {}"
    :actions="actions"
    :advancedSearchOptions="advancedSearchOptions"
    :primary-action-text="canAddProducts ? 'Add Product' : null"
    @primary-action-event="gotoNewProduct"
  />
</template>

<script>
import ApiTable from "@/components/ApiTable";
import request from "@/modules/request";
import ProductService from "@/services/products/product.service";

export default {
  name: "ProductsTable",
  props: {
    actions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    headers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    standardQuery: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    canAddProducts: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      categories: [],
      advancedSearchOptions: [],
      productService: new ProductService(),
    };
  },
  async mounted() {
    await this.initialize();
  },
  components: {
    ApiTable,
  },
  methods: {
    gotoNewProduct() {
      this.$router.push({
        name: "AddProduct",
      });
    },
    async initialize() {
      const { getCategories } = this;
      const results = await Promise.all([getCategories()]);
      const [categories] = results;
      this.categories = categories;
      this.generateAdvancedSearchOptions();
    },
    async getCategories() {
      const opts = {
        method: "get",
      };
      return request
        .callInternal({
          method: "get",
          route: "/api/admin/fullcategories",
        })
        .then((results) => {
          return results.data;
        });
    },
    generateAdvancedSearchOptions() {
      const { categories } = this;
      const options = [
        {
          component: "v-select",
          label: "Select Category",
          items: categories,
          value: "_id",
          key: "category",
          text: "name",
        },
      ];
      this.advancedSearchOptions = options;
    },
  },
};
</script>
